import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//  Get All
export const sendMessageAction = createAsyncThunk(
    "whatsapp/reports/send-message",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(`${APIS.WhatsApp.sendMessage}`, data);
            console.log(res, 'resresres');
            if (res?.success) {
                return res;
            }
            rejectWithValue(res);
        } catch (error) {
            console.log(error, 'resresres');
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const sendMessageToBulkAction = createAsyncThunk(
    "whatsapp/reports/send-messageToBulk",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(`${APIS.WhatsApp.sendMessage}/bulk`, data);
            if (res?.success) {
                return res;
            }
            rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllReceivedMessageReports = createAsyncThunk(
    "whatsapp/reports/get-all-received",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(
                `${APIS.WhatsApp.ReceivedMessageReport}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&endDate=${filter?.endDate || ""}&startDate=${filter?.startDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ReplyMessageAction = createAsyncThunk(
    "whatsapp/reports/status",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.WhatsApp.sendMessage}/reply/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);


// Get Single
export const RecieveMessage = createAsyncThunk(
    "whatsapp/reports/get",
    async (_, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.WhatsApp.ReceiveMessage}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//  Create (Add)
export const Create = createAsyncThunk(
    "whatsapp/reports/create",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.Masters.Template, data);
            if (res?.success) {
                return res; // The new country object
            }
            return rejectWithValue(res)
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


export const sendBulkAction = createAsyncThunk(
    "whatsapp/reports/send-Bulk-new",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(`${APIS.WhatsApp.sendMessage}/bulk-new`, data);
            if (res?.success) {
                return res;
            }
            rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

//  Update
export const Update = createAsyncThunk(
    "whatsapp/reports/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Masters.Template}/${id}`, data);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res)
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//  Delete
export const Delete = createAsyncThunk(
    "whatsapp/reports/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Masters.Template}/${id}`);
            return id; // Return the id of the deleted country
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//  Status
export const StatusUpdate = createAsyncThunk(
    "whatsapp/reports/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Template}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//  Status
export const StatusApproval = createAsyncThunk(
    "whatsapp/reports/status",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Template}/approve/${data?.id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const Slice = createSlice({
    name: "reports",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for RecieveMessage, Create, Update, Delete
            // .addCase(GetAllSendMessageReports.pending, (state) => {
            //     state.status = IDS.SLICESTATUS.Loading;
            // })
            // .addCase(GetAllSendMessageReports.fulfilled, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Succeeded;
            //     state.data = action.payload?.data?.data || [];
            //     state.current_page = action.payload?.data?.current_page || IDS.PAGE;
            //     state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
            //     state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
            //     state.total = action.payload?.data?.total || IDS.TOTAL;
            // })
            // .addCase(GetAllSendMessageReports.rejected, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Failed;
            //     state.error = action.payload;
            // })
            //received message
            .addCase(GetAllReceivedMessageReports.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllReceivedMessageReports.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllReceivedMessageReports.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(RecieveMessage.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(RecieveMessage.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(RecieveMessage.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(sendMessageAction.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(sendMessageAction.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(sendMessageAction.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(sendBulkAction.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(sendBulkAction.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(sendBulkAction.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (reports) => reports.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (reports) => reports.id !== action.payload.id
                );
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(StatusUpdate.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(StatusUpdate.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (reports) => reports.id !== action.payload.id
                ); // Remove the country with the deleted id
            })
            .addCase(StatusUpdate.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
